module.exports = __webpack_public_path__ + "img/boy.0b7d26f4.webp";